<script setup lang="ts" stup>
import type { SubmitResult } from '~/layers/forms/types/submitResult'

interface Props {
  loading: boolean
  loadingMessage?: string
  submitResult: SubmitResult
  resetSubmitResultFunction: () => void
}

withDefaults(defineProps<Props>(), {
  loadingMessage: 'Cargando...',
})

const { LocalConfigurationStore } = stores()
</script>

<template>
  <template v-if="loading">
    <div class="flex w-full justify-center">
      <CardComponent
        class="grid w-full justify-stretch px-5 text-center"
        bg="light"
      >
        <PvProgressBar
          mode="indeterminate"
          class="my-[5px] md:my-[10px] h-[1rem]"
        />
        <span class="text-xs md:text-base">
          {{ loadingMessage }}
        </span>
      </CardComponent>
    </div>
  </template>
  <template v-else-if="submitResult.result">
    <div class="grid justify-center gap-5 pt-8 lg:flex lg:flex-wrap">
      <template v-if="submitResult?.result === 'SUCCESS'">
        <div class="grid justify-center gap-4 text-center">
          <CardComponent
            bg="light"
            class="col-span-full"
          >
            <div class="p-2 text-center text-xl"> Gracias por adquirir nuestro producto </div>
          </CardComponent>
          <div class="grid gap-4 lg:grid-cols-3">
            <CardComponent
              v-for="message of LocalConfigurationStore?.feedbackSubmision?.SUCCESS"
              :key="message.text"
              bg="light"
            >
              <div class="flex flex-col items-center gap-4 p-4">
                <div class="flex items-center justify-center rounded-full bg-primary p-3">
                  <span
                    :class="getIconClass(message.icon)"
                    class="text-3xl text-white"
                  />
                </div>
                <div class="text-center">{{ message.text }}</div>
              </div>
            </CardComponent>
          </div>
        </div>
      </template>
      <template v-if="submitResult?.result === 'FAILED'">
        <div class="text-center">
          <div>
            <span class="icon-[ph--info-bold] text-4xl" />
          </div>
          <template v-if="submitResult.reason">
            {{ LocalConfigurationStore?.feedbackSubmision?.FAILED[submitResult.reason] }}
          </template>
        </div>
      </template>
      <div class="grid gap-4 lg:flex lg:justify-center">
        <PvButton
          v-if="submitResult?.result === 'FAILED'"
          label="Regresar al formulario"
          @click="resetSubmitResultFunction()"
        />
        <PvButton
          label="Volver a la pantalla de inicio"
          severity="contrast"
          outlined
          as="a"
          href="/"
        />
      </div>
    </div>
  </template>
</template>
